module.exports = __webpack_public_path__ + "img/icon_map_3_on_111.001d3108.png";